export type ProjectSearchTaskResult = {
  id: number;
  matched_assignees?: { id: number; name: string }[];
  matched_comments?: string[];
  matches: string[];
};

export type ProjectSearchResults = {
  query: string;
  pageQuery: string;
  matchedAssigneesByTaskId: Record<number, { id: number; name: string }[]>;
  matchedCommentsByTaskId: Record<number, string[]>;
  matchesByTaskId: Record<number, string[]>;
};

export const buildProjectSearchResults = (
  query: string,
  tasks: ProjectSearchTaskResult[],
  pageQuery = ''
): ProjectSearchResults => {
  const results: ProjectSearchResults = {
    query: query.trim(),
    pageQuery: pageQuery.trim(),
    matchedAssigneesByTaskId: {},
    matchedCommentsByTaskId: {},
    matchesByTaskId: {}
  };

  tasks.forEach(task => {
    results.matchesByTaskId[task.id] = task.matches;
    if (task.matched_assignees) {
      results.matchedAssigneesByTaskId[task.id] = task.matched_assignees;
    }
    if (task.matched_comments) {
      results.matchedCommentsByTaskId[task.id] = task.matched_comments;
    }
  });

  return results;
};
